import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SaleziyaniSpivpracivniki = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Салезіянські співпрацівники</h1>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-3 pb-3">
            Салезіянські співпрацівники — це міжнародне об’єднання мирян і дієцезіальних священників, які, не будучи монахами, живуть і служать у дусі салезіянської духовності святого Івана Боско. Вони є повноправною частиною Салезіянської родини та беруть активну участь у її виховній і апостольській місії, насамперед серед дітей і молоді. Спільнота салезіянських співпрацівників була заснована у 1876 році самим святим Іваном Боско, який бачив у мирянах важливу силу для здійснення місії Церкви, адже саме вони можуть діяти безпосередньо в сім’ях, школах, професійному середовищі та ширшому суспільному просторі.
          </div>
          <div className="pt-3 pb-3">
            Дон Боско створив Салезіянських співпрацівників як форму активної участі мирян у салезіянській місії без вимоги складання монаших обітів, заохочуючи їх жити Євангелієм у щоденних обставинах життя. Вони стали першою мирянською гілкою Салезіянської родини та від самого початку тісно співпрацюють із Салезіянами святого Івана Боско, Сестрами Салезіянками та іншими її членами.

          </div>
          <div className="pt-3 pb-3">
            Духовність салезіянських співпрацівників ґрунтується на Превентивній системі святого Івана Боско, яка поєднує розум, релігію та діючу любов. У своєму щоденному житті вони прагнуть бути знаками Божої любові, особливо у стосунках із дітьми та молоддю, свідчачи про християнські цінності через близькість, відповідальність і служіння.
          </div>
          <div className="pt-3 pb-3">
            Салезіянськими співпрацівниками можуть бути миряни та дієцезіальні священники, які не складають монаших обітів, але приймають особисте апостольське зобов’язання жити згідно зі Статутом Салезіянських співпрацівників. Своє покликання вони реалізують у сімейному та професійному житті, через активну участь у парафіях, освітніх і соціальних проєктах, а також у служінні молоді та вихованні християнських цінностей у суспільстві.
          </div>
          <div className="pt-3 pb-3">
            Головною місією салезіянських співпрацівників є апостольська діяльність у світі з особливим наголосом на вихованні дітей і молоді, підтримці родин, катехизації, соціальному служінні та участі в молодіжних і освітніх ініціативах. В Україні салезіянські співпрацівники почали формуватися разом із відновленням діяльності салезіянських спільнот наприкінці XX — на початку XXI століття. Сьогодні вони діють при салезіянських парафіях та осередках, співпрацюючи із салезіянами й салезіянками у спільній місії служіння Церкві та суспільству.
          </div>
        </div>
      </div >
    </>
  );
};

export default SaleziyaniSpivpracivniki;
